export const COMPOSE_ACTIONS = 'common/COMPOSE_ACTIONS';
export const composeActions = (extraActions: Array<Function>) => ({
  type: COMPOSE_ACTIONS,
  payload: {extraActions}
});

export const DELAYED_ACTION = 'common/DELAYED_ACTION';
export const delayedAction = ({delay, action}) => ({
  type: DELAYED_ACTION,
  payload: {delay, action}
});

export {default as commonSaga} from './saga';
